import * as React from 'react';

const FileSeachIcon = (props) => (
  <svg width="81" height="80" viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="40.5" cy="40" r="40" fill="#F9FAFB" />
    <path d="M31.625 39H56.375V64.5C56.375 65.3284 55.7034 66 54.875 66H31.625V39Z" fill="#9B8AFC" />
    <path d="M18.125 39H31.625V66H19.625C18.7966 66 18.125 65.3284 18.125 64.5V39Z" fill="#D9D6FE" />
    <path d="M18.125 39H31.625L26.1815 48H12.5L18.125 39Z" fill="#EAE8FF" />
    <path d="M56.5074 39H31.625L37.25 48H62.375L56.5074 39Z" fill="#EAE8FF" />
    <line x1="36.125" y1="59.25" x2="41.375" y2="59.25" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="36.125" y1="62.25" x2="41.375" y2="62.25" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M56.9866 37.7134L54.8825 35.6094L51.8594 38.6325L53.9622 40.7353C53.8664 41.7055 54.1901 42.7093 54.9332 43.4525L63.2831 51.8024C64.5997 53.119 66.7343 53.119 68.0509 51.8024C69.3675 50.4858 69.3675 48.3512 68.0509 47.0346L59.701 38.6847C58.9585 37.9422 57.9559 37.6184 56.9866 37.7134Z"
      fill="#344054"
    />
    <circle cx="45.125" cy="28.5" r="10.875" fill="#F9FAFB" stroke="#98A2B3" strokeWidth="5.25" />
  </svg>
);
export default FileSeachIcon;
